export default "__VITE_ASSET__6beb0ad3__"